import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface Payload {
  username: string
  planCode: string
}

interface Error {
  response: {
    status: number
  }
}

export const updatePatientDefaultPlan = ({
  username,
  planCode
}: Payload): Promise<void> => {

  const endpoint = apiEndpoints.UPDATE_PATIENT_DEFAULT_PLAN(username, planCode)

  const params = {
    default: true
  }

  return new Promise<void> ((resolve, reject) => {
    axios.patch(endpoint, params)
      .then(() => resolve())
      .catch((error: Error) => {
        reject(error.response?.status)
      })
  })
}
